import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  // Select,
  Space,
  Table,
  Tooltip,
} from "antd";
import {
  PlusOutlined,
  AuditOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { NotificationInfo, UserInfo } from "../../../../context";
import moment from "moment";
import AddPurchaseOrder from "./AddPurchaseOrder";
import PODetails from "./PODetails";

const PurchaseOrder = () => {
  const [poSaveList, setPOSaveList] = useState({
    data: [],
    ready: false,
  });
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [selectedTab, setSelectedTab] = useState("list");
  const [selectedData, setSelectedData] = useState(null);
  const [openFilterByDate, setOpenFilterByDate] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [search, setSearch] = useState("");

  const columns = [
    {
      title: "Date Created",
      dataIndex: "created_at",
      render: (date) => (
        <p>{moment(new Date(date), "YYYY-MM-DD").format("MMMM DD, YYYY")}</p>
      ),
    },
    {
      title: "PO Number",
      dataIndex: "po_number",

      render: (text, record) => (
        <p
          style={{
            color: "blue",
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p>
          <Tooltip title="Details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenDrawer(true);
              }}
              icon={<AuditOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getPOSaveList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/commissary/po-save-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setPOSaveList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getPOSaveList();
  }, [getPOSaveList]);

  const searchable = poSaveList.data.filter((data) => {
    return data.po_number.toLowerCase().indexOf(search.toLowerCase()) >= 0;
  });

  const handleFilter = (values) => {
    var params = {
      date_from: moment(new Date(values.date_from), "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      date_to: moment(new Date(values.date_to), "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      user_id: userData.data.id,
    };
    setLoading(true);
    axios
      .get("user/commissary/filter/po-save-list", { params })
      .then((response) => {
        const data = response.data;
        rerunNotif("success", "Filter successful.");
        setTimeout(() => {
          setOpenFilterByDate(false);
          setLoading(false);
          setPOSaveList({ data, ready: true });
        }, 1000);
      })
      .catch((error) => {
        console.log("Error: ", error);
        // setLoadings(false);
      });
  };

  return (
    <div>
      {selectedTab === "list" && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 5,
            }}
          >
            <div style={{ flexGrow: 1 }}>
              <Input
                placeholder="Search P.O #"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  border: "2px solid #e5e5e5",
                  width: window.innerWidth < 576 ? "100%" : 300,
                }}
                size="large"
              />
            </div>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setSelectedTab("form")}
            >
              Add Purchase
            </Button>

            <Tooltip title="Filter by date">
              <Button
                icon={<CalendarOutlined />}
                style={{ marginLeft: 5 }}
                onClick={() => setOpenFilterByDate(true)}
              >
                Filter
              </Button>
            </Tooltip>
          </div>

          <div style={{ overflowX: "auto" }}>
            <Table
              {...tableProps}
              pagination={{
                position: ["bottomCenter"],
              }}
              columns={tableColumns}
              dataSource={searchable.length > 0 ? searchable : []}
              scroll={scroll}
              rowKey={(record) => record.po_number}
            />
          </div>
        </>
      )}
      {selectedTab === "form" && (
        <AddPurchaseOrder
          close={() => setSelectedTab("list")}
          getPOSaveList={() => getPOSaveList()}
        />
      )}

      {openDrawer && (
        <PODetails
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          selectedData={selectedData}
        />
      )}

      <Modal
        title=""
        open={openFilterByDate}
        onCancel={() => setOpenFilterByDate(false)}
        footer={null}
        width={350}
      >
        <Form
          layout="vertical"
          name="basic"
          initialValues={{ remember: false }}
          onFinish={handleFilter}
          autoComplete="off"
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item
              name="date_from"
              label="Date From"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              name="date_to"
              label="Date To"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loading}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loading ? "Loading" : "Filter"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default PurchaseOrder;
